module.exports = __webpack_public_path__ + "static/media/saxophone.c4f85cdf.svg";